// extracted by mini-css-extract-plugin
export default {"container":"sortedGroup_container__ypMb+","header":"sortedGroup_header__FYnnZ","title":"sortedGroup_title__Fj4tR","toolbar":"sortedGroup_toolbar__vJwhC"};